class CollapsibleHeader extends Collapsible {
  constructor() {
    super();
    this.header = this.closest('[data-header]');
    this.body = document.body;
    if (this.header) {
      this.transparent = !!this.header.classList.contains('header--transparent');
      this.shadow = this.header.querySelector('.header-shadow');

      // extra events
      this.shadow?.addEventListener('click', this.closeAll.bind(this));
    }
  }

  events() {
    if (!this.header) {
      super.events();
    }
  }

  open(group) {
    super.open(group);
    this.toggleHeaderClass(true);
  }

  close(group) {
    super.close(group);
    this.toggleHeaderClass(false);
  }

  closeSiblings(currentGroup = null) {
    super.closeSiblings(currentGroup);
    this.toggleHeaderClass(false);
  }

  openAll() {
    super.openAll();
    this.toggleHeaderClass(true);
  }

  closeAll() {
    super.closeAll();
    this.toggleHeaderClass(false);
  }

  toggleHeaderClass(open = true) {
    if (!this.header) {
      return false;
    }

    if (open) {
      // set header open
      this.header.classList.add('header--is-open');
      this.transparent && this.header.classList.add('header--transparent-scrolled');
      this.body.classList.add('header__menu--is-open');
      this.body.classList.remove('header-search--is-open');
    } else {
      // set header closed if all menu items are closed
      let close = true;
      this.groups.forEach((group) => {
        if (group.classList.contains(this.options.toggleClass)) {
          close = false;
        }
      });
      if (close) {
        this.header.classList.remove('header--is-open');
        this.transparent && this.header.classList.remove('header--transparent-scrolled');
        this.body.classList.remove('header__menu--is-open');
      }
    }
  }
}
class ToggleMobileNavigation extends ToggleElementClass {
  constructor() {
    super();
    this.header = this.closest('[data-header]');
    if (this.header) {
      this.transparent = !!this.header.classList.contains('header--transparent');
      this.shadow = this.header.querySelector('.header-shadow');

      // iPhone fix
      if (navigator.platform === 'iPhone') {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }

      // extra events
      document.addEventListener('keyup', this.onKeyUp.bind(this));
      this.shadow?.addEventListener('click', this.remove.bind(this));
    }
  }

  events() {
    if (!this.header) {
      super.events();
    }
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') {
      return;
    }
    const { toggleClass } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      this.remove();
    }
  }

  add() {
    super.add();
    if (this.header) {
      this.header.classList.add('header--is-open');
      this.transparent && this.header.classList.add('header--transparent-scrolled');
    }
    trapFocus(this.header);
  }

  remove() {
    super.remove();
    if (this.header) {
      this.header.classList.remove('header--is-open');
      this.transparent && this.header.classList.remove('header--transparent-scrolled');
    }
    this.closeAllSibblings();
    removeTrapFocus();
  }

  closeAllSibblings() {
    const collapsibles = this.target.querySelector('collapsible-element');
    collapsibles.closeAll();
  }
}


class ToggleSearch extends ToggleElementClass {
  constructor() {
    super();
  }

  construct() {
    super.construct();
    const { toggleClass, target } = this.options;

    // key up escape
    document.addEventListener('keyup', this.onKeyUp.bind(this));

    // custom close button
    this.closeButton = this.target?.querySelector('[data-close-button]');
    this.closeButton?.addEventListener('click', (e) => {
      this.preventDefault(e);
      this.stopPropagation(e);
      this.remove();
    });

    // click outside search
    document.addEventListener("click", (e) => {
      // if search is open
      if (this.target?.classList.contains(toggleClass)) {
        const isOutside = !e.target.closest(target);
        if (isOutside) {
          this.remove();
        }
      }
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') {
      return;
    }
    const { toggleClass, target } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      this.remove();
    }
  }

  add() {
    super.add();
    const { target } = this.options;
    if (this.target) {
      trapFocus(this.target);
    }
  }

  remove() {
    super.remove();
    removeTrapFocus();
  }
}

class StickyHeader extends HTMLElement {
  constructor() {
    super();

    // select element
    this.header = document.querySelector('#shopify-section-header');
    this.headerWrapper = document.querySelector('.header');
    this.announcementBar = document.querySelector('#shopify-section-announcement-bar');
    this.headerElement = this;
    this.headerTransparent = !!this.headerElement.classList.contains('header--transparent');
    this.headerNav = this.querySelector('collapsible-header');
    this.mobileNav = this.querySelector('toggle-mobile-navigation');
    this.search = this.querySelector('[data-header-search]');
    this.searchToggle = this.querySelector('toggle-search');

    if (this.header) {

      // scroll parameters
      this.currentScrollTop = 0;
      this.scrollOffset = 0;
      this.headerStart = 0;

      if (this.announcementBar) {
        const announcementBarHeight = this.announcementBar.offsetHeight;
        this.scrollOffset += announcementBarHeight;
        this.headerStart += announcementBarHeight;
      }

      // scroll event
      window.addEventListener('scroll', this.onScroll.bind(this), false);
    }
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > this.currentScrollTop && scrollTop > this.scrollOffset) {
      requestAnimationFrame(this.reveal.bind(this));
    } else if (scrollTop <= this.headerStart) {
      requestAnimationFrame(this.revealTop.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeHeaderNav();
    this.closeMobileNav();
    this.closeSearch();
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky');
    this.header.classList.remove('shopify-section-header-hidden');
    if (this.headerTransparent) {
      this.headerElement.classList.add('header--transparent-scrolled');
    }
  }

  revealTop() {
    if (this.headerTransparent && !this.classList.contains('header--is-open')) {
      this.headerElement.classList.remove('header--transparent-scrolled');
    }
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  closeHeaderNav() {
    if (!this.headerNav || window.innerWidth < 768) {
      return false;
    }
    this.headerNav.closeAll();
  }

  closeMobileNav() {
    if(!this.mobileNav) {
      return false;
    }
    this.mobileNav.remove();
  }

  closeSearch() {
    if (!this.search || !this.searchToggle) {
      return false;
    }
    if (this.search.classList.contains('header__search--is-active')) {
      this.searchToggle.remove();
    }
  }
}

if (!customElements.get('collapsible-header')) {
  customElements.define('collapsible-header', CollapsibleHeader);
}

if (!customElements.get('toggle-mobile-navigation')) {
  customElements.define('toggle-mobile-navigation', ToggleMobileNavigation);
}

if (!customElements.get('toggle-search')) {
  customElements.define('toggle-search', ToggleSearch);
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader);
}
